import { AxiosResponse } from "axios";
import AxiosService from "../axios-service/AxiosService";
import Storage from "../storage-service/Storage";

const DOCUMENTATION_BASE_URL: string = "https://dvlw1t13g3v0k.cloudfront.net";

export default class DocumentationService {
    static getDocumentation = async (fileName: string) => {
        const responseDocOrgAndProfile = await this.requestDocFromRemote(
            fileName
        ).catch(() => null);
        if (typeof responseDocOrgAndProfile === "string") {
            return responseDocOrgAndProfile;
        }

        const organizationStorage: string = Storage.get(
            Storage.KEYS.ORGANIZATION_DATA
        ) as string;
        const organizationName: string = JSON.parse(organizationStorage)?.name;
        const responseDocOrg = await this.requestDocFromRemote(
            organizationName
        ).catch(() => null);
        if (typeof responseDocOrg === "string") {
            return responseDocOrg;
        }

        const responseDefaultDoc = await this.requestDocFromRemote().catch(
            () => null
        );
        if (typeof responseDefaultDoc === "string") {
            return responseDefaultDoc;
        }
    };

    private static requestDocFromRemote = async (
        fileName?: string
    ): Promise<any> => {
        Storage.remove(Storage.KEYS.USER_DOCUMENTATION);
        Storage.remove(Storage.KEYS.USER_DOCUMENTATION_NAME);

        const fileDocName: string = fileName ?? "default";

        const fileNameLowerCase: string = `${fileDocName}.md`.toLowerCase();

        const { data }: AxiosResponse = await AxiosService.httpGet(
            `${DOCUMENTATION_BASE_URL}/${fileNameLowerCase}`
        );

        Storage.set(Storage.KEYS.USER_DOCUMENTATION_NAME, fileDocName);
        Storage.set(Storage.KEYS.USER_DOCUMENTATION, data);

        return data;
    };
}
